export default "__VITE_ASSET__CNLxs42i__"